import Vue from 'vue'
import AjaxCart from '../helpers/AjaxCart'
import Helpers from '../helpers/Helpers'

class Cart {
    constructor (theme, elem) {
        this.theme = theme
        this.elem = document.querySelector('section.cart')
        this.vue = null
    }
    async onInit () {
        const _cart = await AjaxCart.getCart()
        this.vue = new Vue({
            el: 'section.cart',
            data: {
                cart: _cart.data || null,
                needsUpdate: false,
                theme: this.theme,
                cartCount: document.querySelector('.user-menu__cart')
            },
            mounted: function () {
                document.addEventListener('cartItemAdded', () => {
                    this.updateCart()
                })
                this.updateCart()
                this.theme.registerComponents(this.$el)
                console.log(this.cart)
            },
            filters: {
                money: (n) => {
                    return Helpers.formatMoney(n)
                }
            },
            methods: {
                updateCart: async function () {
                    let payload = {}
                    this.needsUpdate = false
                    let current = await AjaxCart.getCart()
                    for (let item of current.data.items) {
                        payload[item.key] = item.quantity
                    }
                    if (payload) {
                        const _cart = await AjaxCart.updateItems(payload)
                        if (_cart.status === 200) {
                            this.cart = _cart.data
                        }
                    }
                    if (this.cart.item_count > 0) {
                        this.cartCount.classList.add('items-in-cart')
                        this.cartCount.querySelector('span').textContent = this.cart.item_count
                    } else {
                        this.cartCount.classList.remove('items-in-cart')
                        this.cartCount.querySelector('span').textContent = ''
                    }
                    let tattoo = ''
                    this.cart.items.forEach(item => {
                        if (item.properties.tattoo) {
                            if (!tattoo) {
                                tattoo = item.sku
                            } else {
                                tattoo += `, ${item.sku}`
                            }
                        }
                    })
                    const cartPayload = {attributes: {tattoo: tattoo}}
                    await AjaxCart.updateCart(cartPayload)
                },
                removeItem: async function (item) {
                    item.quantity = 0
                    item.removed = true
                    await AjaxCart.removeItem(item.key)
                    this.updateCart()
                },
                removeTattoo: async function (item) {
                    let id = item.variant_id
                    let quantity = item.quantity
                    let payload = {quantity, id: id}
                    await AjaxCart.addItem(payload)
                    await this.removeItem(item)
                },
                handleChange: async function (item, i) {
                    document.querySelectorAll('.cart__quantity-change').forEach(button => {
                        button.classList.add('working')
                    })
                    this.needsUpdate = true
                    let key = item.key
                    let quantity = item.quantity + i
                    let payload = '{' + key + ': ' + quantity + '}'
                    item.quantity = quantity
                    await AjaxCart.updateItems(payload)
                    payload = {}
                    this.needsUpdate = false
                    for (let item of this.cart.items) {
                        payload[item.key] = item.quantity
                    }
                    if (payload) {
                        const _cart = await AjaxCart.updateItems(payload)
                        if (_cart.status === 200) {
                            this.cart = _cart.data
                        }
                    }
                    document.querySelectorAll('.cart__quantity-change').forEach(button => {
                        button.classList.remove('working')
                    })
                    this.updateCart()
                },
                itemImage: function (src) {
                    return Helpers.getSizedImageUrl(src, '115x115_crop_center')
                },
                itemSizes: function (sizes) {
                    let html = ''
                    const sizesArray = sizes.split('**')
                    sizesArray.forEach(size => {
                        let location = size.split('-')[0].trim().toLowerCase()
                        let sizeShow = size.replace('-', ' ').trim()
                        html += `<span class="${location}">${sizeShow}</span>`
                    })
                    return html
                },
                toggleClass: function (elem, classToAdd) {
                    document.querySelector(elem).classList.toggle(classToAdd)
                }
            }
        })
        window.vueJob = this.vue
    }
}

export default Cart



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Cart.js